import { getAlgoliaProductIndex } from "@utils/configuration/aem";
import {
    PageTemplates,
    isPageTemplate,
} from "@utils/configuration/pageTemplate.helpers";

import { AlgoliaTrackingService } from "@services/algolia/tracking/algoliaTracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { CartProductTrackingInfo } from "@services/tracking/types/trackingInfo/cartProductTrackingInfo";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents,
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAddToCartPayload,
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaClickPayload,
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsAddToCartImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaClickPayload> { }

const getAlgoliaAddToCartPayload = (
    eventData: CartProductTrackingInfo,
): AlgoliaAddToCartPayload => {
    const lastQueryRecord = AlgoliaTrackingService.getLastQueryTrackRecordFor(
        eventData.id,
    );

    const isPDP = isPageTemplate(PageTemplates.PDP);

    return {
        authenticatedUserToken:
            AlgoliaTrackingService.getAuthenticatedUserToken(),
        eventName: isPDP
            ? AlgoliaAnalyticsEventNames.ProductAddToCartPDP
            : AlgoliaAnalyticsEventNames.ProductAddToCartPLP,
        index: getAlgoliaProductIndex(),
        userToken: AlgoliaTrackingService.getUserToken(),
        queryID: lastQueryRecord?.queryID,
        objectIDs: [eventData.id],
        currency: eventData.currencyCode || "EUR",
        objectData: [
            {
                price: eventData.price,
                quantity: eventData.quantity,
            },
        ],
        value: Math.round(eventData.price * eventData.quantity * 100) / 100,
    };
};

const getAlgoliaAnalyticsAddToCartImpression = (
    data: TypedAnalyticsEvent<CartProductTrackingInfo>,
): Array<AlgoliaAnalyticsAddToCartImpression> => {
    const payload = getAlgoliaAddToCartPayload(data.payload.eventData);

    return [
        {
            eventName: payload.queryID
                ? AlgoliaAnalyticsEvents.ProductAddToCartAfterSearch
                : AlgoliaAnalyticsEvents.ProductAddToCartNoSearch,
            payload: payload,
        },
    ];
};

export { getAlgoliaAnalyticsAddToCartImpression };
